import { useDataProvider, useNotify } from "react-admin";
import { StyledButton } from "../../../components/ListShowButton";

interface IRegeneratePdfButton {
  mbcRef: string;
}

const RegeneratePdfButton = ({ mbcRef }: IRegeneratePdfButton) => {
  const provider = useDataProvider();
  const notify = useNotify();
  const docType = mbcRef.substring(0, 2);

  const regeneratePdfUrlInvoice = () => {
    provider
      .customUpdate(`mbc/invoices/${mbcRef}/generatePdf`, {})
      .then(({ data }: any) => {
        notify("Successfully Generate PDF.");
      })
      .catch(() => {
        notify("Error Generate PDF.", "warning");
      });
  };

  const regeneratePdfUrlCreditNote = () => {
    provider
      .customUpdate(`mbc/creditNotes/${mbcRef}/generatePdf`, {})
      .then(({ data }: any) => {
        notify("Successfully Generate PDF.");
      })
      .catch(() => {
        notify("Error Generate PDF.", "warning");
      });
  };

  return (
    <>
      {(docType === "IN" || docType === "CN") && (
        <StyledButton
          variant="outlined"
          onClick={
            docType === "IN"
              ? regeneratePdfUrlInvoice
              : regeneratePdfUrlCreditNote
          }
        >
          Regenerate PDF
        </StyledButton>
      )}
    </>
  );
};

export default RegeneratePdfButton;
